import { render, staticRenderFns } from "./PostsLoader.vue?vue&type=template&id=7789dbab&scoped=true&"
import script from "./PostsLoader.vue?vue&type=script&lang=js&"
export * from "./PostsLoader.vue?vue&type=script&lang=js&"
import style0 from "./PostsLoader.vue?vue&type=style&index=0&id=7789dbab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7789dbab",
  null
  
)

export default component.exports